
import links from "@/config/links";
import { defineComponent } from "vue";
import DocumentList from "@/components/sidebar/DocumentList.vue";
import BenefitsTotal from "@/components/sidebar/BenefitsTotal.vue";
import routesPath from "@/config/routesPath";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "AppSidebar",
  components: { DocumentList, BenefitsTotal },
  data() {
    return {
      links,
      routesPath,
    };
  },
  computed: {
    ...mapGetters(["getEnrollment"]),
    benefitHeader(): string {
      if (this.getEnrollment?.serviceType === 1) {
        return "";
      }

      return "Amount Due Today";
    },
    showBenefitHeader(): boolean {
      return this.getEnrollment?.serviceType !== 1;
    },
  },
  methods: {},
});
